import React from 'react';
import PropTypes from 'prop-types';
import InvoicePdfLink from '~/components/shared/InvoicePdfLink';
export default function PdfViewerLink({invoice, request_id}) {
  return (
    <InvoicePdfLink
      invoice={invoice}
      request_id={request_id}
      is_fleet_car={!!invoice?.fleet_request}
    />
  );
}
PdfViewerLink.propTypes = {invoice: PropTypes.any, request_id: PropTypes.any};
